<div class="dialog-header">
  <div class="header-title">
		<span style="font-size: 120%;">
      #{{cartNumber}} Change Project
		</span>
  </div>

  <button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </button>
</div>


<div class="edit-block">
  <form #userEditForm="ngForm">
    <div class="form-block">
      <div class="form-row">
        <p-listbox [options]="projs" [(ngModel)]="selectedObj" autocomplete="off" [filter]="true"
                   filterMode="startsWith" [filterValue]="searchString" [optionLabel]="'showName'"
                   [ngModelOptions]="{standalone: true}" class="p-list-box-block">
          <p-header>
            Search Project
          </p-header>
        </p-listbox>
      </div>
    </div>

    <div class="save-btn-block">
      <div class="side-block left-side">
        <button mat-button class="empty-btn" (click)="deleteCart()"
                [disabled]="loadingSpinner || deleteCartLoadingSpinner"
                tabindex="1" type="submit"
                [ngClass]="{'disabled-button': loadingSpinner || deleteCartLoadingSpinner}">
          <span *ngIf="!deleteCartLoadingSpinner">Delete</span>
          <lib-mini-progress-spinner *ngIf="deleteCartLoadingSpinner"></lib-mini-progress-spinner>
        </button>
      </div>
      <button mat-button class="save-btn" (click)="save()"
              [disabled]="!selectedObj || loadingSpinner || emptyLoadingSpinner"
              tabindex="1" type="submit"
              [ngClass]="{'disabled-button': !selectedObj || loadingSpinner || emptyLoadingSpinner}">
        <span *ngIf="!loadingSpinner">Select</span>
        <lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
      </button>

      <div class="side-block right-side">
        <button mat-button class="empty-btn" (click)="empty()"
                [disabled]="loadingSpinner || emptyLoadingSpinner"
                tabindex="1" type="submit"
                [ngClass]="{'disabled-button': loadingSpinner || emptyLoadingSpinner}">
          <span *ngIf="!emptyLoadingSpinner">Empty</span>
          <lib-mini-progress-spinner *ngIf="emptyLoadingSpinner"></lib-mini-progress-spinner>
        </button>
      </div>
    </div>
  </form>

</div>
